import { useMemo } from 'react'

import { useFlags } from 'launchdarkly-react-client-sdk'

import { useLocalStorageBackedState } from '~/hooks/useLocalStorageBackedState'

export const useLaunchDarklyFlags = () => {
  const ldFlags = useFlags()
  return { ldFlags }
}

const assessmentsStorageKey = 'feature_assessments'
const zenModeStorageKey = 'feature_zen_mode'

// this hook stores the feature flags in localStorage, which can be changed at runtime
export const useLocalFeatures = () => {
  const [assessments, setAssessments] = useLocalStorageBackedState<boolean>(assessmentsStorageKey, false)
  const [zenMode, setZenMode] = useLocalStorageBackedState<boolean>(zenModeStorageKey, false)
  const featureFlags = useMemo(() => {
    return {
      assessments: {
        title: 'Assessments',
        storageKey: assessmentsStorageKey,
        active: assessments,
        setActive: setAssessments,
      },
      zenMode: {
        title: 'Zen Mode',
        storageKey: zenModeStorageKey,
        active: zenMode,
        setActive: setZenMode,
      },
    } as const
  }, [assessments, setAssessments, setZenMode, zenMode])

  return { featureFlags }
}
